import ReactBSAlert from "react-bootstrap-sweetalert";
import { createRoot } from "react-dom/client";

export const showAlert = ({
  title = "",
  message = null,
  type = "",
  confirmText = "Yes",
  cancelText = "Cancel",
  confirmStyle = "gradient-primary",
  cancelStyle = "secondary",
  showCancel = true,
  showConfirm = true,
  allowOutsideClick = true,
  closeOnConfirm = true,
  onConfirm = () => {},
  onCancel = () => {},
  children = null,
}) => {
  const container = document.createElement("div");
  document.body.appendChild(container);

  const root = createRoot(container);

  const close = () => {
    const cleanup = () => {
      try {
        root.unmount();
      } catch (error) {
        // ignore cleanup errors during React re-render cycles
      }
      if (container.parentNode) {
        container.parentNode.removeChild(container);
      }
    };

    if (typeof window !== "undefined") {
      window.setTimeout(cleanup, 0);
    } else {
      cleanup();
    }
  };

  const confirm = async () => {
    if (closeOnConfirm) close();
    await onConfirm(close);
  };

  const cancel = () => {
    close();
    onCancel();
  };

  root.render(
    <ReactBSAlert
      warning={type === "warning"}
      success={type === "success"}
      info={type === "info"}
      title={<div className="text-dark font-weight-bold h2 mb-2">{title}</div>}
      onConfirm={confirm}
      onCancel={cancel}
      confirmBtnText={confirmText}
      cancelBtnText={cancelText}
      confirmBtnBsStyle={confirmStyle}
      cancelBtnBsStyle={cancelStyle}
      showCancel={showCancel}
      showConfirm={showConfirm}
      allowOutsideClick={allowOutsideClick}
      btnSize=""
    >
      <div className="text-dark opacity-75">{message}</div>
      {children}
    </ReactBSAlert>,
  );

  return close;
};

export const authorizedUser = (res) => {
  if (res?.code === 440) {
    localStorage.clear();
    window.location.href = `/auth/login?error=Your session has expired`;
  } else {
    return;
  }
};

export const formatValues = (value, locale = "en-US") => {
  if (value === null || value === undefined || value === "") return "0";

  const number = Number(value);
  if (isNaN(number)) return "0";

  const hasDecimal = number % 1 !== 0;

  return number.toLocaleString(locale, {
    minimumFractionDigits: hasDecimal ? 2 : 0,
    maximumFractionDigits: 2,
  });
};
